import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { DefaultValueConstants } from '../../constants/default-value-constants';
import { PanelListConstants } from '../../constants/panel-list-constants';
import { DelegationLibraryConstants } from '../../../delegate/delegation-library-constants';
import { UserService } from '../../../my-space/user-profile/user.service';

@Component({
  selector: 'app-stat-card-data',
  templateUrl: './stat-card-data.component.html',
  styleUrls: ['./stat-card-data.component.scss']
})
export class StatCardDataComponent {
  @Input() singleCard: any;

  constructor(private router: Router, private usersService: UsersService, private userService: UserService) { }

  getColorClass(item: any): string {
    if (item.name === DefaultValueConstants.myFavorites_label || item.name === DefaultValueConstants.myAssignedAdmin_label || item.name === DefaultValueConstants.myDelegations_label) {
      return 'bg-blue';
    } else if (item.name === DefaultValueConstants.todelegations_label) {
      return item.count === 0 ? 'bg-green' : 'bg-orange';
    } else {
      return item.count === 0 ? 'bg-green' : 'bg-red';
    }
  }

  getDarkenColorClass(singleCard: any): string {
    const colorClass = this.getColorClass(singleCard);
    const darkenColorClass = `${colorClass}-dark`;
    return darkenColorClass;
  }

  getTotalText(item: any): string {
    if (item.name === DefaultValueConstants.myFavorites_label || item.name === DefaultValueConstants.myAssignedAdmin_label) {
      return DefaultValueConstants.total_label;
    } else if (item.name === DefaultValueConstants.myDelegations_label || item.name === DefaultValueConstants.todelegations_label) {
      return DefaultValueConstants.active_label;
    }
    else {
      return DefaultValueConstants.pending_label;
    }
  }

  loadMyQueues(cardName: string) {
    const menuItems = this.usersService.menuItems;
    const documentItems = menuItems.find(item => item.label === 'Queues');
    const trainingItems = menuItems.find(item => item.label === 'My Space');

    if (cardName === 'My Pending Trainings') {
      cardName = DefaultValueConstants.myUserProfile_label;
    }

    let matchingItem = this.findMatchingItem(documentItems, cardName);
    let trainingMatchingItem = this.findMatchingItem(trainingItems, cardName);

    if (trainingMatchingItem && trainingMatchingItem.routerLink) {
      const url = location.origin.concat("/", trainingMatchingItem.routerLink);
      window.open(url, "_blank");
      return;
    }

    if (!matchingItem && (cardName === DefaultValueConstants.myDelegations_label || cardName === DefaultValueConstants.todelegations_label)) {
      matchingItem = this.findMatchingItem(documentItems, DefaultValueConstants.delegation_label);
    }

    if (!matchingItem && (cardName === DefaultValueConstants.myPeriodicReviews_label)) {
      matchingItem = this.findMatchingItem(documentItems, DefaultValueConstants.myChangeRequests_routerLink);
    }

    if (!matchingItem && (cardName === DefaultValueConstants.myChangeRequests_label)) {
      matchingItem = this.findMatchingItem(documentItems, DefaultValueConstants.myChangeRequests_routerLink);
    }    

    if (!matchingItem && ( cardName === DefaultValueConstants.myEmployees_label)) {
      matchingItem = this.findMatchingItem(trainingItems, DefaultValueConstants.userProfile_label);
    }

    if (!matchingItem) {
      matchingItem = this.findMatchingItem(documentItems, DefaultValueConstants.myAssignedAdmin_label);
    }

    if (matchingItem && matchingItem.routerLink) {
      if (cardName === DefaultValueConstants.myPeriodicReviews_label) {
        const queryparam = PanelListConstants.ChangeRequestItemType_FilterName.concat('=', PanelListConstants.ChangeRequestItemType_PeriodicReview);
        const url = location.origin.concat("/", matchingItem.routerLink, "?", queryparam);
        window.open(url, "_blank");
      }
      else if (cardName === DefaultValueConstants.myChangeRequests_label) {
        const queryparam = PanelListConstants.ChangeRequestItemType_FilterName.concat('=', PanelListConstants.ChangeRequestItemType_Manual);
        const url = location.origin.concat("/", matchingItem.routerLink, "?", queryparam);
        window.open(url, "_blank");
      }
      else if (cardName === DefaultValueConstants.todelegations_label) {
        const queryparam = 'activeTab'.concat('=', DelegationLibraryConstants.TabDelegatedToMe);
        const url = location.origin.concat("/", matchingItem.routerLink, "?", queryparam);
        window.open(url, "_blank");
      }
      else if (cardName === DefaultValueConstants.myEmployees_label) {
        const queryparam = 'activeTab'.concat('=', DefaultValueConstants.TabMyEmployees);
        const url = location.origin.concat("/", matchingItem.routerLink, "?", queryparam);
        window.open(url, "_blank");
      }
      else {
        const url = location.origin.concat("/", matchingItem.routerLink);
        window.open(url, "_blank");
      }
    }

  }

  private findMatchingItem(menu: any, label: string) {
    return menu?.items?.find((item: any) => item.label === label);
  }



}
